import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import fields from '../../lib/fields';
import { RACE_EDIT_FIELDS } from '../../lib/raceEditFields';

import FormFieldsCompact from '../form/fieldsCompact';

/*
 * Edit-race drawer. Same sections, whitelist and auto-save as the admin edit
 * route (routes/race/admin/edit.js), hosted in a bottom drawer so it can be
 * opened from lists such as the tracker calendar.
 *
 * Props: id (race id), onClose (optional, called when the drawer unmounts so
 * the opener can refresh), initialFieldSearch (optional, pre-fills the field
 * filter, e.g. 'trackerkalender' from the tracker calendar), drawerLevel.
 */
@observer
class RaceEditDrawer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('race'),
            loading: true,
        };
    }

    componentDidMount() {
        this.loadRace();
    }

    componentWillUnmount() {
        const { onClose } = this.props;
        if (typeof onClose === 'function') {
            onClose();
        }
    }

    loadRace = async () => {
        const { raceStore } = this.props.stores;
        const { id } = this.props;
        raceStore.updateKeyValue('isRaceAdmin', false);
        await raceStore.load(id, false, { addData: ['raceClassList'] });
        this.setState({ loading: false });
    }

    render() {
        const { sections, loading } = this.state;
        const { drawerLevel = 1, initialFieldSearch = '' } = this.props;
        const { raceStore } = this.props.stores;
        const { race = {} } = raceStore;

        if (loading) {
            return (
                <div class='w-100 d-flex justify-content-center align-items-center' style='min-height: 200px;'>
                    <div class='spinner-border' role='status'>
                        <span class='visually-hidden'>Loading...</span>
                    </div>
                </div>
            );
        }

        return (
            <div class='w-100 pb-5'>
                <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between align-items-center'>
                    <h5 class='mb-0'>
                        <i class='fa-duotone fa-pen me-2' />
                        <Text id='race.edit-race'>Edit race</Text>: {race.title}
                    </h5>
                    <a href={`/race/${race.id}/admin/edit`} class='btn btn-outline-secondary btn-sm rounded-pill'>
                        <i class='fa-solid fa-arrow-up-right-from-square me-1' />
                        <Text id='race.admin-race-edit'>Admin Edit</Text>
                    </a>
                </div>
                <div class='w-100 d-flex flex-column justify-content-start'>
                    <FormFieldsCompact
                        stores={this.props.stores}
                        sections={sections}
                        labelWidth={200}
                        defaultShowOnlyRecommended={true}
                        initialFieldSearch={initialFieldSearch}
                        fields={RACE_EDIT_FIELDS}
                        holdingStore={raceStore}
                        objectName='race'
                        isNew={false}
                        drawerLevel={drawerLevel}
                        isAdmin={false}
                    />
                </div>
            </div>
        );
    }
}

export default RaceEditDrawer;
